<template>
    <div class="tips_page">
        <!-- <Icon type="ios-sad-outline" /> -->
        <div>呀，页面找不到了! 请确认是否有权访问？</div>
        <el-button @click="clickBack" class="fanhui" type="warning">返回</el-button>
    </div>
</template>

<script>
export default {
    methods: {
        clickBack() {
            this.$router.back()
        }
    },
}
</script>

<style scoped>
@import url('./style.css');
</style>